import { render, staticRenderFns } from "./TooltipQuestion.vue?vue&type=template&id=97cee798&scoped=true&"
import script from "./TooltipQuestion.vue?vue&type=script&lang=js&"
export * from "./TooltipQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TooltipQuestion.vue?vue&type=style&index=0&id=97cee798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cee798",
  null
  
)

export default component.exports